"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MapLayer = _interopRequireDefault(require("../../../layers/MapLayer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/* eslint-disable spaced-comment */
/// <reference path="../../../../../../node_modules/@types/googlemaps/index.d.ts" />

/* eslint-enable spaced-comment */


/**
 * `Layer` is a container class that is responsible for creating and managing a Google Maps
 * source and associated layer representation on a Google Maps map.
 */
var GoogleLayer =
/** @class */
function (_super) {
  __extends(GoogleLayer, _super);

  function GoogleLayer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GoogleLayer.prototype.addToMap = function (map) {
    if (this.renderable) {
      this.renderable.setMap(map);
    }
  };

  GoogleLayer.prototype.removeFromMap = function (map) {
    if (this.renderable) {
      this.renderable.setMap(null);
    }
  };

  return GoogleLayer;
}(_MapLayer.default);

var _default = GoogleLayer;
exports.default = _default;
module.exports = exports.default;